import React from 'react';

interface Props {
    kind: 'play' | 'pause' | 'return';
    disc?: boolean;
    className?: string;
}

/** 按蓝湖按钮轮廓绘制矢量图标，避免小尺寸切图放大模糊或边缘裁切。 */
const PhotographyMediaIcon = ({ kind, disc = false, className }: Props) => {
    if (kind === 'return') return <svg className={className} viewBox="0 0 32 28" fill="none" aria-hidden="true" focusable="false">
        <path d="M9 3 3 7l6 4M3 7h17a8 8 0 0 1 0 16H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>;

    return <svg className={className} viewBox={disc ? '0 0 80 80' : '16 16 48 48'} aria-hidden="true" focusable="false">
        {disc && <circle cx="40" cy="40" r="40" fill="#242933" fillOpacity=".7" />}
        {kind === 'play'
            ? <path d="M29 23a2 2 0 0 1 3-1.7l28 17a2 2 0 0 1 0 3.4l-28 17a2 2 0 0 1-3-1.7Z" fill="currentColor" />
            : <g fill="currentColor"><rect x="25" y="22" width="9" height="36" rx="2" /><rect x="46" y="22" width="9" height="36" rx="2" /></g>}
    </svg>;
};

export default PhotographyMediaIcon;
